import { Links } from 'shared/links';

export const getDisabledPages = (investment: any) => {
    const disabledPages = [];
    if (!investment?.enablePromotionsPage) {
        disabledPages.push('/promocje');
    }
    if (!investment?.enableSafeCreditPage) {
        disabledPages.push('/bezpieczny-kredyt');
    }
    if (!investment?.enablePartnersLogos) {
        disabledPages.push('/partnerzy');
    }
    return disabledPages;
};

export const getDynamicPages = (investment: any) => {
    const dynamicPages = [];
    if (investment?.prospectusPdf?.mediaItemUrl) {
        dynamicPages.push({
            link: investment?.prospectusPdf?.mediaItemUrl,
            name: 'Prospekt',
            key: ['prospekt'],
        });
    }
    return dynamicPages;
};

export const getMenuLinks = (disabledPages?: string[]) => {
    return Links.reduce((acc: typeof Links, item) => {
        if (!disabledPages || !disabledPages.includes(item.link)) {
            acc.push(item);
        }
        return acc;
    }, []);
};

export const getMenuDynamicLinks = (dynamicPages?: any[]) => {
    return dynamicPages;
};
